import PropTypes from 'prop-types';

export const HOLDING_INVESTOR_PERFORMANCE_ENTRY_SHAPE = PropTypes.shape({
  portfolio: PropTypes.string,
  currentAllocation: PropTypes.number,
  currentInvestment: PropTypes.number,
  currentPerformance: PropTypes.number,
  currentPnl: PropTypes.number,
  itdPerformance: PropTypes.number,
  itdPnl: PropTypes.number,
  qtdPerformance: PropTypes.number,
  qtdPnl: PropTypes.number,
  ytdPerformance: PropTypes.number,
  ytdPnl: PropTypes.number
});

export const HOLDING_INVESTOR_PERFORMANCE_GROUP_SHAPE = PropTypes.shape({
  holdingName: PropTypes.string,
  groupData: PropTypes.arrayOf(HOLDING_INVESTOR_PERFORMANCE_ENTRY_SHAPE),
  groupTotals: HOLDING_INVESTOR_PERFORMANCE_ENTRY_SHAPE
});
